import React, { useState } from 'react';
import { BookOpen } from 'lucide-react';
import { useLinkLauncher } from '@/contexts/LinkLauncherContext';
import CreateChooserModal from '../CreateChooserModal';
import CourseCanvasDrawer from './CourseCanvasDrawer';

interface CreateModuleModalProps {
    onClose: () => void;
    onSuccess: () => void;
}

// Two doors into course creation:
//   'canvas'  → the wide island slide-over builder (manual editing + in-canvas
//               Link seed + grounding sources + preview toggle). Same drawer
//               used for editing.
//   'ai-chat' → conversational creation with Link. #301: this now opens the
//               GLOBAL Link (the FAB) with a STAGED (unsent) create prompt rather
//               than rendering its own inline surface — one Link, always on.
type CreationMethod = 'chooser' | 'canvas';

const CreateModuleModal: React.FC<CreateModuleModalProps> = ({ onClose, onSuccess }) => {
    const [method, setMethod] = useState<CreationMethod>('chooser');
    const { stageLink } = useLinkLauncher();

    // Canvas builder — the wide island slide-over (no page navigation).
    if (method === 'canvas') {
        return <CourseCanvasDrawer onClose={onClose} onSaved={onSuccess} />;
    }

    return (
        <CreateChooserModal
            title="Skapa modul"
            question="Hur vill du skapa modulen?"
            onClose={onClose}
            manual={{
                icon: BookOpen,
                title: 'Skapa modul',
                description: 'Bygg modulen själv — lägg till steg manuellt, eller låt Link skapa ett utkast (med eller utan ditt material) som du redigerar fritt.',
                onClick: () => setMethod('canvas'),
            }}
            link={{
                title: 'Få hjälp av Link',
                description: 'Beskriv modulen i en chatt. Link ställer frågor, föreslår en plan och bygger modulen åt dig medan du tittar på.',
                // #301 — open the global Link (FAB) with a staged, unsent
                // create-course prompt; the user reviews + sends.
                onClick: () => {
                    onClose();
                    stageLink({ prompt: 'Hjälp mig att skapa en ny onboarding-modul.' });
                },
            }}
        />
    );
};

export default CreateModuleModal;
